import { useSsrAdapter as C } from "../../../../../@css-render_vue3-ssr@0.15.14_vue@3.5.18/node_modules/@css-render/vue3-ssr/esm/index.js";
import "../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { c as H } from "../_utils/cssr/index.js";
import { configProviderInjectionKey as O } from "../config-provider/src/context.js";
import { throwError as S } from "../_utils/naive/warn.js";
import { inject as N, watchEffect as P } from "../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import h from "../../../../../@emotion_hash@0.8.0/node_modules/@emotion/hash/dist/hash.browser.esm.js";
import { ref as R } from "../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function M(v, s, i, p) {
  i || S("useThemeClass", "cssVarsRef is not passed");
  const t = N(O, null), r = t == null ? void 0 : t.mergedThemeHashRef, g = t == null ? void 0 : t.styleMountTarget, n = R(""), y = C();
  let o;
  const T = `__${v}`, $ = () => {
    let e = T;
    const l = s ? s.value : void 0, m = r == null ? void 0 : r.value;
    m && (e += `-${m}`), l && (e += `-${l}`);
    const {
      themeOverrides: f,
      builtinThemeOverrides: a
    } = p;
    f && (e += `-${h(JSON.stringify(f))}`), a && (e += `-${h(JSON.stringify(a))}`), n.value = e, o = () => {
      const d = i.value;
      let u = "";
      for (const c in d)
        u += `${c}: ${d[c]};`;
      H(`.${e}`, u).mount({
        id: e,
        ssr: y,
        parent: g
      }), o = void 0;
    };
  };
  return P(() => {
    $();
  }), {
    themeClass: n,
    onRender: () => {
      o == null || o();
    }
  };
}
export {
  M as useThemeClass
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_mixins/use-css-vars-class.js
// module id = 21
// module chunks = 41